import React, { FC, ReactElement } from 'react';
import ParseHtml from '../common/ParseHtml';
import withLocalization from '../hoc/withLocalization';

const TermsAndConditionSelector: FC<any> = (props: any): ReactElement => {
  const { localize } = props;

  return (
    <>
      <div className="checkPaymentBox">
        <ParseHtml
          htmlInput={localize('preview-sales-engine.static-content.copy.Labels.labels#terms-of-condition-label')}
        />
      </div>
    </>
  );
};

export default withLocalization(TermsAndConditionSelector);
